var $ = require('jquery');
require('../vendors/match-height/match-height')($);

var MatchHeight = function ClientSlider($element, options) {
	var $services = $('.icon-text-block');
	if($services.length) {
		$services.matchHeight();
	}

	var $textOverlay = $('.image-text-overlay-block');
	if($textOverlay.length) {
		$textOverlay.matchHeight();
	}

	var $transInterp = $('.translators-interpreters .block');
	if($transInterp.length) {
		$transInterp.matchHeight();
	}
}

module.exports = MatchHeight;